import api from ".";
import { benchmarkingEndpoints } from "./endpoints/benchmarking.endpoints";

export const benchmarkingApis = {
  getAnalysis: async (reportId, benchmarkType, customTargets) => {
    const res = await api.post(
      benchmarkingEndpoints.getAnalysis(reportId, benchmarkType),
      { customTargets: customTargets || {} },
    );
    return res.data;
  },
};
